import { FUEL_TYPE_UNITS, FuelType } from "@/constants/FuelTypeGroups";
import { formatNumber as formatSharedNumber } from "@/utilities/formatNumber";

export function formatNumber(value: number, language: string, fractionDigits: number): string {
  return formatSharedNumber(value, language, { precision: fractionDigits, missing: "" });
}

export function formatDistance(value: number, language: string, fractionDigits: number): string {
  return `${formatNumber(value, language, fractionDigits)} km`;
}

export function formatConsumption(
  value: number | undefined,
  fuelType: FuelType | undefined,
  language: string,
): string {
  if (value == null || !fuelType) return "";
  return `${formatNumber(value, language, 1)} ${FUEL_TYPE_UNITS[fuelType]}`;
}

/** Driving time as `h:mm:ss`, like the digital Fahrtenbuch's Fahrtdauer. */
export function formatDuration(ms: number): string {
  const total = Math.max(0, Math.round(ms / 1000));
  const hours = Math.floor(total / 3600);
  const minutes = Math.floor((total % 3600) / 60);
  const seconds = total % 60;
  return `${hours}:${String(minutes).padStart(2, "0")}:${String(seconds).padStart(2, "0")}`;
}
